
import piModelAdd from "./components/pi-model-add.vue";
import piNewAdd from "./components/pi-new-add.vue";
import { Component, Vue } from "vue-property-decorator";
import { getModelListPage, delOneModel } from "@/api/api-basic";
import { getOptionList, optionKey } from "@/api/api-dict";
import { objAny } from "@/common/common-interface";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-model-add": piModelAdd,
    "pi-new-add": piNewAdd
  }
})
export default class EquipmentModel extends Vue {
  // private test: string = "light";
  private privilege: objAny = {};

  private piModelAdd: objAny = {};
  private piNewAdd: objAny = {};

  private modelList = [];
  private oprList = [];
  private devTypeList: object[] = [];

  private total = 0;
  private time: object[] = [];

  private formInline: objAny = {
    deviceType: "",
    startTime: "",
    endTime: "",

    globalPageIndex: 1,
    globalPageSize: 10,
    globalOrder: "",
    globalSearch: ""
  };
  private ruleInline = {};
  private loading = false;
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      type: "selection",
      width: 40,
      align: "center"
    },
    {
      title: i18n.t("equipmentModel.deviceType"),
      key: "deviceTypeDesc",
      resizable: true,
      minWidth: 130
      // slot: "deviceType"
    },
    {
      title: i18n.t("equipmentModel.deviceModelName"),
      key: "deviceModelName",
      resizable: true,
      minWidth: 130
    },
    {
      title: i18n.t("equipmentModel.standard"),
      key: "sn",
      resizable: true,
      minWidth: 130,
      slot: "standard"
    },
    {
      title: i18n.t("equipmentModel.matching"),
      resizable: true,
      minWidth: 130,
      slot: "matching"
    },
    {
      title: i18n.t("equipmentModel.manufacturerName"),
      key: "manufacturerName",
      resizable: true,
      minWidth: 120
    },
    {
      title: i18n.t("reportFile.archiveCode"), //"报告编号",
      key: "deviceArchiveCode",
      minWidth: 120
    },
    {
      title: i18n.t("reportFile.attachmentRecordPkId"), //"型式试验报告",
      minWidth: 130,
      slot: "typeNo"
    },
    {
      title: i18n.t("equipmentModel.updateTime"),
      key: "modifyTime",
      resizable: true,
      minWidth: 140,
      // slot: "modifyTime",
      render: (h: Function, params: objAny) => {
        if (params.row.modifyTime) {
          return h(
            "div",
            this.$common.userDate(
              new Date(params.row.modifyTime),
              "yyyy-MM-dd HH:MM:SS"
            )
          );
        } else {
          return h("div", "--");
        }
      }
    },
    {
      title: i18n.t("operation"),
      resizable: true,
      minWidth: 140,
      slot: "action"
    }
  ];
  private selectList: object[] = [];
  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  async getOptionList() {
    const ret = await getOptionList([optionKey.devTypeList]); //请求字典
    this.devTypeList = ret[optionKey.devTypeList]; // 客户名称
  }
  public selectItem(list: object[]) {
    const chooseList: object[] = [];
    list.map((item: objAny) => {
      chooseList.push(item.deviceModelPkId);
    });
    this.selectList = chooseList;
  }
  // public queryAlarm(): void {
  //   this.getTableList();
  // }
  public addEquipment(): void {
    this.piModelAdd.open();
  }
  public addNewAbout(): void {
    this.piNewAdd.open();
  }

  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public detailBtn(item: objAny): void {
    this.piNewAdd.open(item, "detail");
  }
  public updModel(item: objAny): void {
    this.piNewAdd.open(item, "update");
  }
  public deleteModel(item: objAny): void {
    this.$Modal.confirm({
      title: i18n.t("tips") + "",
      content: i18n.t("equipmentModel.delDeviceModelName") + "",
      onOk: () => {
        this.delItemModel(item.deviceModelPkId);
      }
    });
  }
  public deleteSome(): void {
    if (this.selectList.length === 0) {
      this.$Message.error(i18n.t("equipmentModel.minSelectItem") + "");
    } else {
      this.$Modal.confirm({
        title: i18n.t("tips") + "",
        content: i18n.t("equipmentModel.delDeviceModelName") + "",
        onOk: () => {
          this.delItemModelSome();
        }
      });
    }
  }

  async getTableList(): Promise<void> {
    // if (this.formInline.startTime == "" || this.formInline.endTime == "") {
    //   this.$Message.error("更新时间不能为空 !");
    //   return;
    // }
    this.loading = true;
    const ret = await getModelListPage(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }

  // 删除
  async delItemModel(deviceModelPkId: string): Promise<void> {
    const deviceModelPkIds = [deviceModelPkId];
    const ret = await delOneModel({ deviceModelPkIds });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.getTableList();
    }
  }

  // 批量删除
  async delItemModelSome(): Promise<void> {
    const ret = await delOneModel({ deviceModelPkIds: this.selectList });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.getTableList();
    }
  }
  private timeFn(val: objAny): void {
    if (val[0] !== "" && val[1] !== "") {
      this.formInline.startTime = this.$common.userDate(val[0]).split(" ")[0];
      this.formInline.endTime = this.$common.userDate(val[1]).split(" ")[0];
    } else {
      this.formInline.startTime = "";
      this.formInline.endTime = "";
    }
  }
  public created(): void {
    // const startTime = this.$common.thisTimes("yyyy-MM");
    // const endTime = this.$common.thisTimes("yyyy-MM-dd");
    // this.formInline.startTime = startTime + "-01";
    // this.formInline.endTime = endTime;
    // this.time = [this.formInline.startTime, this.formInline.endTime];
    this.getOptionList();
    this.getTableList();
    // this.searchInitData();
  }

  mounted() {
    this.$nextTick((): void => {
      this.piModelAdd = this.$refs["piModelAdd"];
      this.piNewAdd = this.$refs["piNewAdd"];
    });
    this.privilege = this.$route.meta.privilegeVoObj;
  }
}
